module.exports = __webpack_public_path__ + "img/shop-service-filter-chevy.1565aed2.png";